import { buildModelManager } from "../builder.js";
const DefaultShopifyInventoryLevelSelection = {
  __typename: true,
  id: true,
  adminGraphqlApiId: true,
  available: true,
  canDeactivate: true,
  createdAt: true,
  deactivationAlert: true,
  inventoryItemId: true,
  locationId: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyInventoryLevel";
const pluralModelApiIdentifier = "shopifyInventoryLevels";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByInventoryItem",
    findByField: "inventoryItemId",
    findByVariableName: "inventoryItemId",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByInventoryItem",
    findByField: "inventoryItemId",
    findByVariableName: "inventoryItemId",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryLevelSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyInventoryLevelGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyInventoryLevel does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyInventoryLevelManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyInventoryLevelSelection,
  operations
);
export {
  DefaultShopifyInventoryLevelSelection,
  ShopifyInventoryLevelManager
};
//# sourceMappingURL=ShopifyInventoryLevel.js.map
